import React, { PureComponent } from 'react';
import { OrderArrowContainer } from './styled';
import icons from '../treatedIcons';

const { OrderArrow } = icons;

export default class OrderContainer extends PureComponent {
  static defaultProps = {
    changeCurrent: () => console.warn('Missing function!'),
    current: '',
    sort: '',
    tag: ''
  }

  changeOrder = () => {
    this.props.changeCurrent(this.props.tag);
  }

  render() {
    const sort = (this.props.current === this.props.tag)? this.props.sort : '';
    return (
      <OrderArrowContainer onClick={this.changeOrder}>
        {this.props.children && this.props.children}
        <OrderArrow order={sort} />
      </OrderArrowContainer>
    );
  }

}
